import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import { formatCurrency, getLink } from "../../../utils/helpers";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";

class Tipos extends Component {
    state = {
        tipos: {},
        tipo: {},
        links: null,
        meta: null,
        showCreate: false,
        showEdit: false,
        loading: true,
    };
    componentDidMount() {
        this.getTipos();
    }
    getTipos = async (url = null) => {
        url = url ? url + "&limit=15" : "tipos?limit=15";
        const tipos = await this.props.request(url);

        if (tipos.links) {
            this.setState({
                tipos: tipos.data,
                links: tipos.links,
                meta: tipos.meta,
                loading: false,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            tipo: {},
        });
    };
    toggleEditModal = (tipo) => {
        this.setState({
            showEdit: !this.state.showEdit,
            tipo: tipo,
        });
    };
    render() {
        const { tipos, loading } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Tipos de Empleados</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Tipo de Empleado
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!tipos.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            No hay ningún tipo de empleado
                                            creado.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Sueldo Fijo</th>
                                                <th>Descuento</th>
                                                <th>Tipo</th>
                                                <th className='text-center'>
                                                    Empleados Activos
                                                </th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tipos.map((tipo) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={tipo.id}>
                                                    <td>{tipo.nombre}</td>
                                                    <td>
                                                        {formatCurrency(
                                                            tipo.sueldoFijo
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatCurrency(
                                                            tipo.descuento
                                                        )}
                                                    </td>
                                                    <td>{tipo.tipoNomina}</td>
                                                    <td className='text-center'>
                                                        {tipo.empleados}
                                                    </td>
                                                    <td>
                                                        <div className='table-data-feature'>
                                                            <button
                                                                className='item'
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title=''
                                                                data-original-title='Edit'
                                                                onClick={() => {
                                                                    this.toggleEditModal(
                                                                        tipo
                                                                    );
                                                                }}>
                                                                <i className='zmdi zmdi-edit' />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getTipos}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        tipo={this.state.tipo}
                        getTipos={this.getTipos}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        tipo={this.state.tipo}
                        getTipos={this.getTipos}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Tipos);
